module.exports = __webpack_public_path__ + "img/ico-signal.560ae86f.svg";